import React from "react";
import { WHATSAPP_LINK } from "@/lib/packages";

export default function WhatsAppFloat() {

  /*return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 wa-pulse w-14 h-14 rounded-full flex items-center justify-center shadow-lg"
      style={{ background: "#25D366" }}
      aria-label="WhatsApp"
    >
      <svg viewBox="0 0 24 24" width="26" height="26" fill="#fff" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.79.47 3.48 1.32 4.95L2 22l5.25-1.37a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.85 9.85 0 0 0 12.04 2Zm5.79 14.09c-.25.7-1.44 1.35-2.01 1.4-.53.06-1.19.09-1.92-.12-.44-.14-1.02-.33-1.75-.65-3.08-1.33-5.09-4.44-5.24-4.64-.15-.2-1.25-1.66-1.25-3.17 0-1.51.79-2.25 1.07-2.56.28-.31.61-.39.82-.39.2 0 .41.002.59.01.19.007.44-.07.69.53.25.6.85 2.08.93 2.23.08.15.13.33.03.53-.1.2-.15.32-.31.5-.15.18-.32.4-.46.53-.15.15-.31.31-.13.61.18.3.81 1.33 1.74 2.16 1.19 1.06 2.19 1.39 2.5 1.55.31.15.49.13.68-.08.19-.2.79-.91 1-1.22.2-.31.41-.26.69-.16.28.1 1.77.84 2.08.99.31.15.51.23.59.36.08.13.08.75-.17 1.45Z"/>
      </svg>
    </a>
  );*/
  return("");
}
